import React, { useState } from 'react';
import { Heart, Play, Music, ExternalLink, Image as ImageIcon } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const fmt = (n) => (n == null ? '—' : n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${(n / 1e3).toFixed(1)}K` : n);

const Thumb = ({ src }) => {
  const [failed, setFailed] = useState(false);
  if (!src || failed) return <div className="w-full h-full flex items-center justify-center text-[#A1A1AA]"><ImageIcon size={22} /></div>;
  return <img src={`${API_URL}/api/creator-ideation/thumb?url=${encodeURIComponent(src)}`} alt="" loading="lazy" onError={() => setFailed(true)} className="w-full h-full object-cover" />;
};

export const TrendingGrid = ({ niche, posts, error }) => (
  <section data-testid="creator-ideation-trending">
    <h2 className="text-lg font-semibold text-[#0F0F0F] dark:text-white mb-3">What's trending in {niche} right now</h2>
    {error && <p className="text-sm text-[#6B6B6B] dark:text-zinc-400 mb-3" data-testid="creator-ideation-trending-error">{error}</p>}
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4">
      {posts.map((p, i) => (
        <a key={p.url} href={p.url} target="_blank" rel="noopener noreferrer" className="group rounded-xl overflow-hidden border border-black/[0.08] dark:border-white/5 bg-white dark:bg-[#0F1115] hover:border-[#FF451A]/40 transition-colors" data-testid={`creator-ideation-trend-${i}`}>
          <div className="aspect-[4/5] bg-black/[0.04] dark:bg-white/[0.03] relative">
            <Thumb src={p.thumbnail} />
            <ExternalLink size={13} className="absolute top-2 right-2 text-white opacity-0 group-hover:opacity-100 transition-opacity drop-shadow" />
          </div>
          <div className="p-3 space-y-1.5">
            <div className="flex gap-3 text-[11px] font-mono text-[#0F0F0F] dark:text-white">
              <span className="inline-flex items-center gap-1"><Play size={11} />{fmt(p.views)}</span>
              <span className="inline-flex items-center gap-1"><Heart size={11} />{fmt(p.likes)}</span>
            </div>
            <p className="text-[11px] text-[#4B5563] dark:text-zinc-300 line-clamp-3">{p.caption || '—'}</p>
            {p.audio && <p className="text-[10px] text-[#6B6B6B] dark:text-zinc-400 truncate inline-flex items-center gap-1"><Music size={10} />{p.audio}</p>}
            <p className="text-[10px] text-[#FF451A] truncate">{(p.hashtags || []).slice(0, 4).map((h) => `#${h}`).join(' ')}</p>
          </div>
        </a>
      ))}
    </div>
  </section>
);
